import React, { useEffect, useState } from 'react'
import { addWithQuantity } from '../../Redux/Slice/Cart/cartSlice'
import { useDispatch } from 'react-redux'
import toast from 'react-hot-toast'
import { useLocation } from 'react-router-dom'
import { getSingleProducts } from '../../Services/ShopServices'

const useShopDetail = () => {

    const [isLoading, setIsLoading] = useState(false)
    const [products, setProducts] = useState(null)
    const [itemQuantity, setItemQuantity] = useState(1)
    const [color, setColor] = useState("")
    const [size, setSize] = useState("")
    const [weight, setWeight] = useState("")
    const [selectedVariation, setSelectedVariation] = useState("")

    const handleSize = (value) => {
        console.log("Selected Size:", value);
        setSize(value);

        let singleVariation;
        if (color) {
            singleVariation = products?.variation?.find(
                (product) => product?.type.toLowerCase() === `${value.toLowerCase()}-${color.toLowerCase()}`
            );
        } else if (weight) {
            singleVariation = products?.variation?.find(
                (product) => product?.type.toLowerCase() === `${value.toLowerCase()}-${weight.toLowerCase()}`
            );
        }

        console.log("singleVariation:", singleVariation);
        setSelectedVariation(singleVariation);
    };

    const handleColor = (value) => {
        console.log("Selected Color:", value);
        setColor(value);

        let singleVariation;
        if (size) {
            singleVariation = products?.variation?.find(
                (product) => product?.type.toLowerCase() === `${size.toLowerCase()}-${value.toLowerCase()}`
            );
        } else if (weight) {
            singleVariation = products?.variation?.find(
                (product) => product?.type.toLowerCase() === `${weight.toLowerCase()}-${value.toLowerCase()}`
            );
        }

        console.log("singleVariation:", singleVariation);
        setSelectedVariation(singleVariation);
    };

    const handleWeight = (value) => {
        console.log("Selected Weight:", value);
        setWeight(value);

        if (!products?.variation) {
            console.error("products.variation is undefined");
            return;
        }

        let singleVariation;
        if (color) {
            singleVariation = products.variation.find((product) => {
                const formattedType = product?.type?.toLowerCase();
                const formattedSearch = `${color.toLowerCase()}-${value.toLowerCase()}`;

                console.log("Checking:", formattedType, " === ", formattedSearch); // Debugging
                return formattedType === formattedSearch;
            });
        } else if (size) {
            singleVariation = products.variation.find((product) => {
                const formattedType = product?.type?.toLowerCase();
                const formattedSearch = `${color.toLowerCase()}-${value.toLowerCase()}`;

                console.log("Checking:", formattedType, " === ", formattedSearch); // Debugging
                return formattedType === formattedSearch;
            });
        }

        console.log("singleVariation:", singleVariation || "Not Found");
        setSelectedVariation(singleVariation);
    };

    const location = useLocation();
    const productId = location.state?.id;

    const handleGetProduct = async () => {
        setIsLoading(true)
        let response = await getSingleProducts(productId)
        if (response.statusCode === 200) {
            setProducts(response?.response?.data)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    const handleIncreament = () => {
        if (selectedVariation?.qty && itemQuantity < selectedVariation.qty) {
            setItemQuantity(itemQuantity + 1);
        }
    }

    const handleDecreament = () => {
        if (itemQuantity > 1) {

            setItemQuantity(itemQuantity - 1)
        }
    }

    useEffect(() => {
        handleGetProduct();
    }, [])

    const dispatch = useDispatch()

    const handleAddToCart = () => {
        if (products?.choice_options) {
            for (let item of products.choice_options) {
                if (item?.type?.toLowerCase() === "size" && !size) {
                    toast?.error("Please select size");
                    return;
                }
                if (item?.type?.toLowerCase() === "weight" && !weight) {
                    toast?.error("Please select weight");
                    return;
                }
                if (item?.type?.toLowerCase() === "colour" && !color) {
                    toast?.error("Please select color");
                    return;
                }
            }
        }

        let obj = {
            id: products?.id,
            img: products?.image_url,
            title: products?.title,
            price: selectedVariation?.price,
            quantity: itemQuantity,
            variant_name: selectedVariation?.type
        };

        dispatch(addWithQuantity(obj));
        toast?.success("Added to cart")
    };
    return [
        products,
        selectedVariation,
        color,
        itemQuantity,
        handleColor,
        handleSize,
        handleWeight,
        handleIncreament,
        handleDecreament,
        handleAddToCart
    ]
}

export default useShopDetail